/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ResourceSearchItem} from '../models/ResourceSearchItem';

export interface SearchResources$Request {
    resourceName: string;
    accountId?: number;
    userId?: number;
    includeDatasets?: boolean;
}

export interface SearchResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchResourcesRequest = createAction<PayloadData<void, SearchResources$Request>>('ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_RESOURCES__REQUEST');
export const searchResourcesSuccess = createAction<PayloadData<Array<ResourceSearchItem>, SearchResources$Request>>('ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_RESOURCES__SUCCESS');
export const searchResourcesFailure = createAction<PayloadData<Error, SearchResources$Request, true>>('ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_RESOURCES__FAILURE');

export const searchResourcesActions = [
    searchResourcesRequest,
    searchResourcesSuccess,
    searchResourcesFailure
] as const;

/**
 * @param {string} meta.resourceName
 * @param {number} [meta.accountId]
 * @param {number} [meta.userId]
 * @param {boolean} [meta.includeDatasets]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchResources = (meta: SearchResources$Request, config?: SearchResources$Config) => {
    const TRANSPORT_GET_PARAMS = {
        resourceName: meta.resourceName,
        accountId: meta.accountId,
        userId: meta.userId,
        includeDatasets: meta.includeDatasets,
    };
    return {
        CALL_API: {
            types: searchResourcesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/resources/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

